import { configureStore } from "@reduxjs/toolkit";
import menuSlice from "./menuSlice";
import modalSlice from "./modalSlice";
import { blogApi } from "./services/blogServices";
import { userApi } from "./services/userServices";
import authSlice from "./authSlice";
import { accessoryApi } from "./services/accessoryServices";
import { listingApi } from "./services/listingServices";
import alertSlice from "./alertSlice";
import userSlice from "./userSlice";
import { bodyTypeApi } from "./services/bodyTypeServices";
import { exteriorColorApi } from "./services/exteriorColorServices";
import { fuelApi } from "./services/fuelServices";
import selectedListingsSlice from "./selectedListingsSlice";
import { brandApi } from "./services/brandServices";
import accessoryBrandSelectSlice from "./accessoryBrandSelectSlice";
import characteristicsModalSlice from "./characteristicsModalSlice";
import { propertyTypeApi } from "./services/propertyTypeServices";
import { heatingTypeApi } from "./services/heatingTypeServices";
import { characteristicsApi } from "./services/characteristicsServices";
import { subPropertyTypeApi } from "./services/subPropertyServices";
import { furnishingTypeApi } from "./services/furnishingTypeServices";
import createItemModalSlice from "./createItemModalSlice";
import editItemModalSlice from "./editItemModalSlice";
import { locationsTypeApi } from "./services/locationsServices";
import { equipmentsApi } from "./services/equipmentsServices";
import { chatApi } from "./services/chatsServices";
import ratingViewSlice from "./ratingViewSlice";
import { ratingApi } from "./services/ratingServices";
import deleteItemSlice from "./deleteItemSlice";
import { campaignApi } from "./services/campaignsServices";
import { packageApi } from "./services/packageServices";
import { paymentApi } from "./services/paymentServices";
import { adminApi } from "./services/adminServices";
import { analyticsApi } from "./services/analyticsServices";
import { platformApi } from "./services/platformServices";
import { customPackageApi } from "./services/customPackageServices";
import { deleteReasonApi } from "./services/deleteReasonServices";
import { userListingsApi } from "./services/userListingsServices";
import { companyPlanApi } from "./services/companyPlanServices";
import { companyReportApi } from "./services/companyReportServices";
import { bannerApi } from "./services/bannerServices";
import { auditLogApi } from "./services/auditLogServices";
import { adminNotificationApi } from "./services/adminNotificationServices";
import { adminAccessApi } from "./services/adminAccessServices";

const store = configureStore({
    reducer: {
        user: userSlice.reducer,
        menu: menuSlice.reducer,
        modal: modalSlice.reducer,
        create_item_modal: createItemModalSlice.reducer,
        edit_item_modal: editItemModalSlice.reducer,
        auth: authSlice.reducer,
        alert: alertSlice.reducer,
        characteristics_modal: characteristicsModalSlice.reducer,
        selectedListings: selectedListingsSlice.reducer,
        accessoryBrandSelect: accessoryBrandSelectSlice.reducer,
        rating_view: ratingViewSlice.reducer,
        delete_item: deleteItemSlice.reducer,
        [listingApi.reducerPath]: listingApi.reducer,
        [blogApi.reducerPath]: blogApi.reducer,
        [userApi.reducerPath]: userApi.reducer,
        [accessoryApi.reducerPath]: accessoryApi.reducer,
        [bodyTypeApi.reducerPath]: bodyTypeApi.reducer,
        [exteriorColorApi.reducerPath]: exteriorColorApi.reducer,
        [fuelApi.reducerPath]: fuelApi.reducer,
        [brandApi.reducerPath]: brandApi.reducer,
        [propertyTypeApi.reducerPath]: propertyTypeApi.reducer,
        [subPropertyTypeApi.reducerPath]: subPropertyTypeApi.reducer,
        [heatingTypeApi.reducerPath]: heatingTypeApi.reducer,
        [characteristicsApi.reducerPath]: characteristicsApi.reducer,
        [furnishingTypeApi.reducerPath]: furnishingTypeApi.reducer,
        [locationsTypeApi.reducerPath]: locationsTypeApi.reducer,
        [equipmentsApi.reducerPath]: equipmentsApi.reducer,
        [chatApi.reducerPath]: chatApi.reducer,
        [ratingApi.reducerPath]: ratingApi.reducer,
        [campaignApi.reducerPath]: campaignApi.reducer,
        [packageApi.reducerPath]: packageApi.reducer,
        [paymentApi.reducerPath]: paymentApi.reducer,
        [adminApi.reducerPath]: adminApi.reducer,
        [analyticsApi.reducerPath]: analyticsApi.reducer,
        [platformApi.reducerPath]: platformApi.reducer,
        [customPackageApi.reducerPath]: customPackageApi.reducer,
        [deleteReasonApi.reducerPath]: deleteReasonApi.reducer,
        [userListingsApi.reducerPath]: userListingsApi.reducer,
        [companyPlanApi.reducerPath]: companyPlanApi.reducer,
        [companyReportApi.reducerPath]: companyReportApi.reducer,
        [bannerApi.reducerPath]: bannerApi.reducer,
        [auditLogApi.reducerPath]: auditLogApi.reducer,
        [adminNotificationApi.reducerPath]: adminNotificationApi.reducer,
        [adminAccessApi.reducerPath]: adminAccessApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            listingApi.middleware,
            blogApi.middleware,
            userApi.middleware,
            accessoryApi.middleware,
            bodyTypeApi.middleware,
            exteriorColorApi.middleware,
            fuelApi.middleware,
            brandApi.middleware,
            propertyTypeApi.middleware,
            subPropertyTypeApi.middleware,
            heatingTypeApi.middleware,
            characteristicsApi.middleware,
            furnishingTypeApi.middleware,
            locationsTypeApi.middleware,
            equipmentsApi.middleware,
            chatApi.middleware,
            ratingApi.middleware,
            campaignApi.middleware,
            packageApi.middleware,
            paymentApi.middleware,
            adminApi.middleware,
            analyticsApi.middleware,
            platformApi.middleware,
            customPackageApi.middleware,
            deleteReasonApi.middleware,
            userListingsApi.middleware,
            companyPlanApi.middleware,
            companyReportApi.middleware,
            bannerApi.middleware,
            auditLogApi.middleware,
            adminNotificationApi.middleware,
            adminAccessApi.middleware,
        ),
})

export default store;